import React from 'react';
import { 
  FaFacebookF, 
  FaInstagram, 
  FaTwitter, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaClock,
  FaGem,
  FaArrowRight,
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaPaypal,
  FaShieldAlt
} from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Column 1 - Brand Info */}
          <div>
          <div className="flex items-center gap-2 mb-4">
            <img 
              src="/logo1.png" 
              alt="SKK Jewellers Logo" 
              className="w-18 h-14 object-contain"
            />
            </div>
            <p className="text-sm text-gray-400 mb-4 leading-relaxed">
              Discover timeless elegance with our handcrafted jewellery. 
              Premium quality certified pieces that celebrate your special moments.
            </p>
            <div className="flex gap-3">
              <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-amber-500 hover:text-white transition-all duration-300">
                <FaFacebookF className="w-4 h-4" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-amber-500 hover:text-white transition-all duration-300">
                <FaInstagram className="w-4 h-4" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-full hover:bg-amber-500 hover:text-white transition-all duration-300">
                <FaTwitter className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4 relative inline-block">
              Quick Links
              <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-amber-500 mt-1"></div>
            </h4>
            <ul className="space-y-2">
              {['Home', 'Collections', 'Jewelry', 'Diamonds', 'About Us', 'Contact'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-gray-400 hover:text-amber-500 text-sm transition-colors duration-300 flex items-center gap-2">
                    <FaArrowRight className="w-3 h-3" />
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Contact Info */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4 relative inline-block">
              Contact Us
              <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-amber-500 mt-1"></div>
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <FaPhoneAlt className="w-4 h-4 text-amber-500 mt-0.5" />
                <div>
                  <p className="text-sm text-gray-400">+91 9839949895</p>
                  <p className="text-sm text-gray-400">+91 9285668748</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <FaEnvelope className="w-4 h-4 text-amber-500 mt-0.5" />
                <p className="text-sm text-gray-400">info@skkjewellers.com</p>
              </li>
              <li className="flex items-start gap-3">
                <FaMapMarkerAlt className="w-4 h-4 text-amber-500 mt-0.5" />
                <p className="text-sm text-gray-400">
                  123, Jewelry Market, <br />
                  Andheri East, Mumbai - 400069
                </p>
              </li>
              <li className="flex items-start gap-3">
                <FaClock className="w-4 h-4 text-amber-500 mt-0.5" />
                <p className="text-sm text-gray-400">
                  Mon - Sun: 11:00 AM - 8:00 PM
                </p>
              </li>
            </ul>
          </div>

          {/* Column 4 - Newsletter & Payment */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4 relative inline-block">
              Stay Updated
              <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-amber-500 mt-1"></div>
            </h4>
            <p className="text-sm text-gray-400 mb-3">
              Subscribe to get updates on new collections and exclusive offers.
            </p>
            <div className="flex mb-4">
              <input 
                type="email" 
                placeholder="Your email address"
                className="flex-1 px-3 py-2 text-sm bg-gray-800 border border-gray-700 rounded-l-lg focus:outline-none focus:border-amber-500 text-white"
              />
              <button className="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-3 py-2 rounded-r-lg hover:from-amber-600 hover:to-amber-700 transition-all duration-300">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 my-8"></div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">
            © {currentYear} SKK Jewellers. All rights reserved.
          </p>
          
          <div className="flex items-center gap-4 text-xs">
            <a href="privacy" className="text-gray-500 hover:text-amber-500 transition-colors">
              Privacy Policy
            </a>
            <span className="text-gray-700">|</span>
            <a href="terms" className="text-gray-500 hover:text-amber-500 transition-colors">
              Terms & Conditions
            </a>
            <span className="text-gray-700">|</span>
            <a href="returns" className="text-gray-500 hover:text-amber-500 transition-colors">
              Returns Policy
            </a>
          </div>

          <div className="flex items-center gap-2">
            <FaShieldAlt className="w-3 h-3 text-amber-500" />
            <span className="text-xs text-gray-500">100% Secure Payments</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;